import React from "react";
import { SEO as Seo } from "../components/UI/seo";
import Cafetera from "../components/Cafetera/Cafetera";

const RecipesPage = () => {
  return (
    <>
      <Cafetera />
    </>
  );
};

export default RecipesPage;

export const Head = () => (
  <Seo title="Cafetera PE-CE5007IXN | Peabody">
    <link rel="canonical" href="https://peabody.com.ar/cafetera/"/>
  </Seo>
)
